<template >
    <div class="energyData">
        <div class="bg">
            <dv-loading v-if="loading">Loading...</dv-loading>
            <div v-else class="host-body">
                <div class="d-flex jc-center">
                    <dv-decoration-10 class="dv-dec-10" />
                    <div class="d-flex jc-center">
                        <dv-decoration-8 class="dv-dec-8" :color="decorationColor" />
                        <div class="title">
                            <span class="title-text">能耗数据概览</span>
                            <!-- <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']" /> -->
                        </div>
                        <dv-decoration-8 class="dv-dec-8" :reverse="true" :color="decorationColor" />
                    </div>
                    <dv-decoration-10 class="dv-dec-10-s" />
                </div>

                <dv-border-box-1 style="width:100%;height:auto;" :color="['#0099FE', '#0099FE']">
                    <div style="padding:20px 30px;">
                        <div style="display:flex;color: #ffffff;align-items: center;">
                            <div style="line-height:40px;font-size: 30px; display: flex;">
                                {{ dateDay }}
                            </div>
                            <div style="margin-left:15px;">
                                <div style="line-height:20px;">{{ dateYear }}</div>
                                <div style="line-height:20px;">{{ dateWeek }}</div>
                            </div>
                        </div>
                        <!-- 第一行 -->
                        <div class="line1">
                            <div class="line1-item">
                                <div class="line1-title">
                                    <img src="../../../assets/imgs/data111.png" />
                                    <div>今日能耗</div>
                                </div>
                                <div class="line1-right">
                                    <div>
                                        <div>能耗总量</div>
                                        <div class="mun">{{ daySum }}</div>
                                    </div>
                                    <div>
                                        <div>A栋能耗</div>
                                        <div class="mun">{{ dayA }}</div>
                                    </div>
                                    <div>
                                        <div>B栋能耗</div>
                                        <div class="mun">{{ dayB }}</div>
                                    </div>
                                    <div>
                                        <div>C栋能耗</div>
                                        <div class="mun">{{ dayC }}</div>
                                    </div>
                                </div>

                            </div>


                            <div class="line1-item">
                                <div class="line1-title">
                                    <img src="../../../assets/imgs/data111.png" />
                                    <div>本月能耗</div>
                                </div>
                                <div class="line1-right">
                                    <div>
                                        <div>能耗总量</div>
                                        <div class="mun">{{ monSum }}</div>
                                    </div>
                                    <div>
                                        <div>A栋能耗</div>
                                        <div class="mun">{{ monA }}</div>
                                    </div>
                                    <div>
                                        <div>B栋能耗</div>
                                        <div class="mun">{{ monB }}</div>
                                    </div>
                                    <div>
                                        <div>C栋能耗</div>
                                        <div class="mun">{{ monC }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="line1-item">
                                <div class="line1-title">
                                    <img src="../../../assets/imgs/data111.png" />
                                    <div>年度能耗</div>
                                </div>
                                <div class="line1-right">
                                    <div>
                                        <div>能耗总量</div>
                                        <div class="mun">{{ yearSum }}</div>
                                    </div>
                                    <div>
                                        <div>A栋能耗</div>
                                        <div class="mun">{{ yearA }}</div>
                                    </div>
                                    <div>
                                        <div>B栋能耗</div>
                                        <div class="mun">{{ yearB }}</div>
                                    </div>
                                    <div>
                                        <div>C栋能耗</div>
                                        <div class="mun">{{ yearC }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 第二行 -->
                        <div class="line1">
                            <div class="line1-item" ref="line">
                                <dv-border-box-13 :style="'width:100%;padding:10px;height:100%;'">
                                    <div style="margin-top:10px;display: flex;">
                                        <div style="margin-left:10px;text-align: left;">波峰波谷图</div>
                                        <div style="display: flex;align-items: center;margin-left:10px;">
                                            <el-select v-model="build" size="mini" style="width: 70px;margin-right:10px;"
                                                @change="changeSeach1();">
                                                <el-option label="A栋" value="A"></el-option>
                                                <el-option label="B栋" value="B"></el-option>
                                                <el-option label="C栋" value="C"></el-option>
                                            </el-select>
                                            <!-- <el-date-picker size="mini" type="daterange" value-format="yyyy-MM-dd"
                                                range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                                v-model="queryDate1" style="width: 220px;" @change="changeSeach1();"
                                                :clearable="false"></el-date-picker> -->
                                        </div>
                                    </div>

                                    <div class="leftEcharts2" ref="leftEcharts2"></div>
                                </dv-border-box-13>
                            </div>
                            <div class="line1-item">
                                <dv-border-box-2 style="padding:10px;text-align: center;height:100%;">
                                    <!-- <el-divider content-position="center"> -->
                                    <div style="font-size: 18px;margin-top:10px;">
                                        能耗情况
                                    </div>
                                    <!-- </el-divider> -->
                                    <div style="font-size:22px;margin-top:10px;">
                                        {{ allSum }}
                                    </div>
                                    <div style="display:flex;justify-content:center;margin-top: 30px;">
                                        <div>
                                            <el-progress :width="110" type="circle" :percentage="yearRatio"></el-progress>
                                            <div>同比</div>
                                        </div>
                                        <div style="margin-left: 40px;">
                                            <el-progress :width="110" type="circle" :percentage="linkRatio"
                                                :color="[{ color: '#6f7ad3' }]"></el-progress>
                                            <div>环比</div>
                                        </div>

                                    </div>
                                </dv-border-box-2>
                            </div>
                            <div class="line1-item">
                                <dv-border-box-13 style="padding:10px;height:100%;">
                                    <div style="margin-top:10px;display: flex;justify-content: space-between;">
                                        <div style="margin-left:20px;text-align: left;">商铺时段能耗</div>
                                        <div style="margin-right:10px;display: flex;align-items: center;">
                                            <!-- <el-date-picker size="mini" type="monthrange" value-format="yyyy-MM"
                                                range-separator="-" start-placeholder="开始年月" end-placeholder="结束年月"
                                                v-model="queryDate2" style="width: 200px;" @change="changeSeach2();"
                                                :clearable="false"></el-date-picker> -->
                                        </div>
                                    </div>
                                    <div class="rightEcharts2" ref="rightEcharts2"></div>
                                </dv-border-box-13>
                            </div>
                        </div>


                        <!-- 第三行 -->
                        <div class="line1">
                            <div class="line1-item">
                                <dv-border-box-12 style="width:100%;padding:10px;">
                                    <div style="margin-top:10px;display: flex;">
                                        <div style="margin-left:20px;text-align: left;">区域能耗</div>
                                        <div style="margin-right:10px;display: flex;align-items: center;margin-left:50px;">
                                            <!-- <el-date-picker size="mini" type="monthrange" value-format="yyyy-MM"
                                                range-separator="-" start-placeholder="开始年月" end-placeholder="结束年月"
                                                v-model="queryDate3" style="width: 200px;" @change="changeSeach3();"
                                                :clearable="false"></el-date-picker> -->
                                        </div>
                                    </div>
                                    <div class="leftEcharts3" ref="leftEcharts3"></div>
                                </dv-border-box-12>
                            </div>
                            <div class="line1-item">
                                <dv-border-box-6 style="padding:10px;">
                                    <div style="margin-top:10px;margin-left:20px;text-align: left;">
                                        BA数据
                                    </div>
                                    <div
                                        :style="'width:' + (lineWidth - 20) + 'px;display:flex;align-items: center;margin-top:15px;font-size: 14px;font-weight: 350;'">
                                        <div style="height:194px;background-color: #DE4835;" class="textCenter ">
                                            空 调
                                        </div>
                                        <div style="width:50%;">
                                            <div class="left1">
                                                <div class="leftBC">回风温度
                                                    <div> 0°</div>
                                                </div>
                                                <div class="leftBC">回风湿度
                                                    <div> 0°</div>
                                                </div>
                                            </div>
                                            <div class="left1" style="margin-top:6px;">
                                                <div class="leftBC">回风二氧化碳浓度
                                                </div>
                                                <div class="leftBC">预热温度</div>
                                            </div>
                                        </div>
                                        <div style="margin-left:6px;width:50%;">
                                            <div style="display:flex;height:94px;">
                                                <div style="background-color: #068B62;" class="textCenter ">
                                                    新 风
                                                </div>
                                                <div class="right1BC">
                                                    <div>
                                                        <div>送风温度</div>
                                                        <div> 0°</div>
                                                    </div>
                                                </div>
                                                <div class="right1BC">
                                                    <div>
                                                        <div> 送风湿度</div>
                                                        <div> 0°</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="display:flex;margin-top:6px;height:94px;">
                                                <div style="background-color: #0676BE;" class="textCenter ">
                                                    给 排 水
                                                </div>
                                                <div class="right2BC">水管压力</div>
                                                <div class="right2BC">水泵频率</div>
                                            </div>
                                        </div>
                                    </div>

                                </dv-border-box-6>
                            </div>
                            <div class="line1-item">
                                <dv-border-box-12 style="width:100%;padding:10px;">
                                    <div style="margin-top:10px;display: flex;">
                                        <div style="margin-left:20px;text-align: left;">功能系统</div>
                                        <div style="margin-right:10px;display: flex;align-items: center;margin-left:50px;">
                                            <!-- <el-date-picker size="mini" type="monthrange" value-format="yyyy-MM"
                                                range-separator="-" start-placeholder="开始年月" end-placeholder="结束年月"
                                                v-model="queryDate4" style="width: 200px;" @change="changeSeach4();"
                                                :clearable="false"></el-date-picker> -->
                                        </div>
                                    </div>
                                    <!-- <div class="rightEcharts3" ref="rightEcharts3"></div> -->
                                    <dv-scroll-ranking-board :style="'width:' + (lineWidth - 40) + 'px'" :config="config"
                                        class="rightEcharts3" />
                                </dv-border-box-12>
                            </div>
                        </div>



                    </div>
                </dv-border-box-1>
            </div>
        </div>
    </div>
</template>
  
<script>
import echarts from "echarts";
import { formatTime1 } from '../../../utils/index.js'
import ScaleBox from 'vue2-scale-box'
var dayjs = require('dayjs')
export default {
    components: {
        ScaleBox
    },
    data() {
        return {
            allSum: "",
            yearRatio: "",
            linkRatio: "",
            monSum: 0,
            monA: 0,
            monB: 0,
            monC: 0,
            yearSum: 0,
            yearA: 0,
            yearB: 0,
            yearC: 0,
            daySum: 0,
            dayA: 0,
            dayB: 0,
            dayC: 0,
            config: {},
            build: "A",
            queryDate1: [],
            queryDate2: [],
            queryDate3: [],
            queryDate4: [],
            timing: null,
            loading: true,
            dateDay: null,
            dateYear: null,
            dateWeek: null,
            weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            decorationColor: ['#568aea', '#000000'],
            lineWidth: 0,
        }
    },
    created() {
        this.timeFn();
        this.setMonth();
        this.getTop();
    },
    mounted() {
        this.cancelLoading();
        setTimeout(() => {
            this.lineWidth = this.$refs.line.offsetWidth;
            this.changeSeach1();
            this.changeSeach3();
            this.setRightEcharts2();
            this.changeSeach4();
        }, 500)
        window.addEventListener("resize", () => this.Refresh());
        window.addEventListener('setItem', () => {

            // alert( this.lineWidth )
            // if (sessionStorage.getItem('leftWidth') == 0) {
            //     this.lineWidth = this.lineWidth + 66
            // } else {
            //     this.lineWidth = this.lineWidth - 66
            // }
        })
    },
    beforeDestroy() {
        clearInterval(this.timing)
        // 销毁
        window.removeEventListener("resize");
    },
    methods: {
        getTop() {
            //  type    (1:今日，2:本月，3:年度)
            this.$http.get(`/api/energy/getEnergyForDate?type=1`).then(res => {
                if (res.data.code == 0) {
                    let sum = 0;
                    res.data.data.forEach(element => {
                        sum = sum + Number(element.sum)

                        if (Number(element.sum) > 999999) {
                            element.sum = (element.sum / 10000).toFixed(1) + "w"
                        }
                        if (element.building == 'A') {

                            this.dayA = element.sum
                        }
                        if (element.building == 'B') {
                            this.dayB = element.sum
                        }
                        if (element.building == 'C') {
                            this.dayC = element.sum
                        }
                    });
                    if (Number(sum) > 999999) {
                        sum = (sum / 10000).toFixed(1) + "w"
                    }
                    this.daySum = sum
                }
            })
            this.$http.get(`/api/energy/getEnergyForDate?type=2`).then(res => {
                if (res.data.code == 0) {
                    let sum = 0;
                    res.data.data.forEach(element => {
                        sum = sum + Number(element.sum)

                        if (Number(element.sum) > 999999) {
                            element.sum = (element.sum / 10000).toFixed(1) + "w"
                        }
                        if (element.building == 'A') {
                            this.monA = element.sum
                        }
                        if (element.building == 'B') {
                            this.monB = element.sum
                        }
                        if (element.building == 'C') {
                            this.monC = element.sum
                        }
                    });
                    if (Number(sum) > 999999) {
                        sum = (sum / 10000).toFixed(1) + "w"
                    }
                    this.monSum = sum
                }
            })
            this.$http.get(`/api/energy/getEnergyForDate?type=3`).then(res => {
                if (res.data.code == 0) {
                    let sum = 0;
                    res.data.data.forEach(element => {
                        sum = sum + Number(element.sum)

                        if (Number(element.sum) > 999999) {
                            element.sum = (element.sum / 10000).toFixed(1) + "w"
                        }
                        if (element.building == 'A') {
                            this.yearA = element.sum
                        }
                        if (element.building == 'B') {
                            this.yearB = element.sum
                        }
                        if (element.building == 'C') {
                            this.yearC = element.sum
                        }
                    });
                    if (Number(sum) > 999999) {
                        sum = (sum / 10000).toFixed(1) + "w"
                    }
                    this.yearSum = sum
                }
            })

            this.$http.get(`/api/energy/getEnergyConsumption`).then(res => {
                console.log(res)
                if (res.data.code == 0) {
                    if (Number(res.data.data.sum) > 999999) {
                        res.data.data.sum = (res.data.data.sum / 10000).toFixed(1) + "w"
                    }
                    this.allSum = res.data.data.sum
                    this.yearRatio = res.data.data.yearRatio
                    this.linkRatio = res.data.data.linkRatio
                }
            })
        },
        changeSeach1() {
            this.$http.post(`/api/energy/getPeaksAndTroughs`, {
                building: this.build,
                startTime: this.queryDate1[0],
                endTime: this.queryDate1[1]
            }).then(res => {
                if (res.data.code == 0) {
                    console.log(res.data)
                    let xArr = []
                    let yArr = []
                    res.data.data.forEach(element => {
                        xArr.push(element.date)
                        yArr.push(element.sum)
                    });
                    this.setLeftEcharts2(xArr, yArr);
                }
            })
        },
        changeSeach2() { this.queryDate2; },
        changeSeach3() {
            this.$http.post(`/api/energy/getRinglike`, {
                startTime: this.queryDate3[0],
                endTime: this.queryDate3[1]
            }).then(res => {
                if (res.data.code == 0) {
                    let arr = []
                    res.data.data.forEach(element => {
                        let item = {
                            name: element.type,
                            value: element.sum || 0
                        }
                        arr.push(item)
                    });
                    this.setLeftEcharts3(arr);
                }
            })
        },
        changeSeach4() {
            // this.queryDate4;
            this.$http.post(`/api/energy/getFunctional`, {
                startTime: this.queryDate4[0],
                endTime: this.queryDate4[1]
            }).then(res => {
                if (res.data.code == 0) {
                    let arr = []
                    res.data.data.forEach(element => {
                        let item = {
                            name: element.type,
                            value: element.sum || 0
                        }
                        arr.push(item)
                    });
                    this.config = {
                        data: arr
                    }
                }
            })

        },
        setRightEcharts2() {
            this.$http.get(`/api/energy/timePeriodEnergyConsumption`).then(res => {
                if (res.data.code == 0) {
                    let xArr = []
                    let yArr = [];
                    res.data.data.forEach(element => {
                        xArr.push(element.readingTime)
                        yArr.push(element.positiveElec)
                    });
                    let option = {
                        backgroundColor: "",
                        tooltip: {
                            trigger: "axis"
                        },
                        grid: {
                            top: "30",
                            left: "3%",
                            right: "4%",
                            bottom: "3%",
                            containLabel: true
                        },
                        xAxis: {
                            type: "category",
                            axisTick: {
                                show: false //轴线刻度
                            },
                            boundaryGap: false,
                            data: xArr,
                            axisLabel: {
                                color: "#ffffff",
                                interval: 0,
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#ffffff" //x轴颜色
                                }
                            }
                        },
                        color: ["#277CD5"],
                        yAxis: {
                            type: "value",
                            axisTick: {
                                show: false //轴线刻度
                            },
                            axisLabel: {
                                color: "#ffffff",
                                formatter: '{value}kW·h'
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#ffffff" //Y轴颜色
                                }
                            },
                            splitLine: {
                                lineStyle: {
                                    color: "#505687"
                                }
                            }
                        },
                        series: [{
                            // name: "Highest",
                            data: yArr,
                            type: "line",
                            symbolSize: 8,
                            areaStyle: {
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0.1,
                                    color: "#212a61"
                                },
                                {
                                    offset: 1,
                                    color: "#277CD5"
                                }
                                ])
                            },
                            smooth: true,
                            // markPoint: {
                            //     data: [{ type: "max", name: "Max" }, { type: "min", name: "Min" }]
                            // },
                            // label: {  //显示值
                            //     show: true,
                            //     position: 'top'
                            //   },
                        }]
                    };
                    this.$echarts.init(this.$refs.rightEcharts2, "dark").setOption(option);
                }
            })


        },

        setLeftEcharts2(xArr, yArr) {
            // let xArr = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            // let yArr = [820, 932, 901, 934, 1290, 1330, 1320];

            let option = {
                dataZoom: {
                    show: true,
                    realtime: true,
                    y: 8,
                    height: 15,
                    // start: 10,
                    // end: 80,
                    type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
                    startValue: 0, // 从头开始。
                    endValue: 4, // 一次性展示10个
                    brushSelect: false, //刷选功能，设为false可以防止拖动条长度改变 ************（这是一个坑）
                },
                backgroundColor: "",
                tooltip: {
                    trigger: "axis"
                },
                grid: {
                    top: "55",
                    left: "10",
                    right: "35",
                    bottom: "0",
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    axisTick: {
                        show: false //轴线刻度
                    },
                    boundaryGap: false,
                    data: xArr,
                    axisLabel: {
                        color: "#ffffff",
                        interval: 0,
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#ffffff" //x轴颜色
                        }
                    }
                },
                color: ["#277CD5"],
                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false //轴线刻度
                    },
                    axisLabel: {
                        color: "#ffffff",
                        formatter: '{value}kW·h'
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#ffffff" //Y轴颜色
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#505687"
                        }
                    }
                },
                series: [{
                    // name: "Highest",
                    data: yArr,
                    type: "line",
                    symbolSize: 0,
                    // areaStyle: {
                    //     color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    //         offset: 0.1,
                    //         color: "#212a61"
                    //     },
                    //     {
                    //         offset: 1,
                    //         color: "#277CD5"
                    //     }
                    //     ])
                    // },
                    smooth: true,
                    markPoint: {
                        data: [{ type: "max", name: "Max" }, { type: "min", name: "Min" }]
                    },
                    // label: {  //显示值
                    //     show: true,
                    //     position: 'top'
                    //   },
                }]
            };
            this.$echarts.init(this.$refs.leftEcharts2, "dark").setOption(option);
        },
        setLeftEcharts3(arr) {



            let option = {
                grid: {
                    top: "0",
                    left: "10",
                    right: "40",
                    bottom: "0",
                    containLabel: true
                },
                title: {
                    // text: '',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: 'bottom'
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['30%', '60%'],
                        data: arr,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: '#ffffff'
                            }
                        }
                    }
                ]
            };
            this.$echarts.init(this.$refs.leftEcharts3, 'dark').setOption(option);
        },
        timeFn() {
            this.timing = setInterval(() => {
                this.dateDay = formatTime1(new Date(), 'HH : mm')
                this.dateYear = formatTime1(new Date(), 'yyyy-MM-dd')
                this.dateWeek = this.weekday[new Date().getDay()]
            }, 1000)
        },
        cancelLoading() {
            setTimeout(() => {
                this.loading = false
            }, 500)
        },
        Refresh() {
            this.$router.go(0);
        },
        setMonth() {
            let year = new Date().getFullYear()
            let mon = new Date().getMonth() + 1
            // mon = mon - 1
            if (mon <= 0) {
                year = year - 1
                mon = mon + 12
            }
            if (mon < 10) {
                mon = '0' + mon
            }
            let queryMonth = year + '-' + mon;
            //获取今天日期
            let dateEnd = dayjs().format('YYYY-MM-DD')
            //获取过去/未来N天的日期  前几天
            let dateStart = dayjs().subtract(29, 'day').format('YYYY-MM-DD')
            this.queryDate1 = [dateStart, dateEnd]
            this.queryDate2 = [queryMonth, queryMonth]
            this.queryDate3 = [queryMonth, queryMonth]
            this.queryDate4 = [queryMonth, queryMonth]
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables.scss';

.energyData {
    //     width: 100vw;
    //   height: 100vh;
    background-color: #091631;
    // overflow: hidden;
    color: #d3d6dd;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: left top;
    overflow-x: hidden;
    overflow-y: auto;

    .bg {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center center;
    }

    .host-body {
        padding: 10px 5px 0 5px;

        .dv-dec-10,
        .dv-dec-10-s {
            width: 33.3%;
            height: 5px;
        }

        .dv-dec-10-s {
            transform: rotateY(180deg);
        }

        .dv-dec-8 {
            width: 200px;
            height: 50px;
        }

        .title {
            position: relative;
            width: 500px;
            text-align: center;
            background-size: cover;
            background-repeat: no-repeat;


            .title-text {
                font-size: 28px;
                position: absolute;
                bottom: 0px;
                left: 50%;
                transform: translate(-50%);
                color: #ffffff;
            }

            .dv-dec-6 {
                position: absolute;
                bottom: 10px;
                left: 50%;
                width: 250px;
                height: 8px;
                transform: translate(-50%);
            }
        }

        .leftEcharts2 {
            height: 200px;
        }

        .leftEcharts3 {
            height: 200px;
        }

        .rightEcharts2 {
            height: 220px;
        }

        .rightEcharts3 {
            height: 210px;
            margin-left: 10px;
        }

        ::v-deep .el-progress__text {
            color: #ffffff !important;
        }

        ::v-deep .dv-scroll-ranking-board .ranking-info .rank {
            display: none;
        }

        .left1 {
            height: 94px;
            width: 100%;
            display: flex;

            .leftBC {
                background-color: #DE4835;
                width: 50%;
                height: 100%;
                margin-left: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
            }


        }

        .right1BC {
            background-color: #068B62;
            width: 50%;
            height: 100%;
            margin-left: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
        }

        .right2BC {
            background-color: #0676BE;
            width: 50%;
            height: 100%;
            margin-left: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
        }

        .textCenter {
            width: 30px;
            color: black;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;
            writing-mode: vertical-rl;

        }

        .line1 {
            display: flex;
            justify-content: space-around;
            font-size: 17px;
            color: #ffffff;
            margin-top: 30px;
            font-weight: 450;

            .line1-item {
                display: flex;
                align-items: center;
                width: 33%;

                .line1-title {
                    background-color: #1E4082;
                    width: 150px;
                    padding: 20px;
                    display: flex;
                    text-align: center;
                    align-items: center;

                    img {
                        width: 30px;
                        height: 30px;
                        margin-right: 10px;
                    }
                }

                .line1-right {
                    display: flex;
                    align-items: center;
                    flex: 1;
                    justify-content: space-around;
                    text-align: center;
                    height: 70px;
                    background-color: #102658;

                    .mun {
                        color: #FF6600;
                        margin-top: 5px;
                    }
                }
            }
        }
    }
}
</style>
